import { useApiClient } from '@hetivo/hetivo-lib-front-utils';
import type { Territory } from '@hetivo/hetivo-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { createTerritoryApi, territoryKeys } from '../api';

export function useTerritory(id: string, enabled = true): UseQueryResult<Territory> {
  const client = useApiClient('admin-auth');
  const api = createTerritoryApi(client);

  return useQuery({
    enabled: enabled && !!id,
    gcTime: 5 * 60_000,
    queryFn: () => api.getTerritory(id),
    queryKey: territoryKeys.detail(id),
    staleTime: 30_000,
  });
}
